import React from 'react';
import {
  Stack,
  Typography,
  Card,
  Tooltip,
  Icon,
  IconButton,
  Alert
} from 'investira.react.components';
import { formats, validators } from 'investira.sdk';
import { CONFERENCIA_CUSTODIANTE_DIVERGENCIA } from '../../../../enums';
import { toTitleCase } from 'investira.sdk/lib/utils/strings';

const Highlights = props => {
  const { data } = props;
  const hasDivergencias = !validators.isEmpty(data.response?.resumo.estatisticas.divergencias);

  const xDescricao =
    data.response?.resumo.estatisticas.divergencias[CONFERENCIA_CUSTODIANTE_DIVERGENCIA.AUSLCL.id]
      ?.descricao ||
    data.response?.resumo.estatisticas.divergencias[CONFERENCIA_CUSTODIANTE_DIVERGENCIA.AUSCUST.id]
      ?.descricao;

  const xStatus = hasDivergencias
    ? xDescricao
      ? {
          text: toTitleCase(xDescricao)?.replace('No', 'no'),
          color: 'error.light'
        }
      : {
          text: 'Com Divergências',
          color: 'warning.main'
        }
    : {
        text: 'OK!',
        color: 'primary.main'
      };

  return (
    <>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        sx={{ gap: 1, justifyContent: 'space-between' }}
        component="section"
        flexGrow={1}>
        <Stack sx={{ gap: 1, flex: 1 }}>
          <Stack gap={1} flexGrow={1}>
            <Card
              sx={{
                flex: 1,
                display: 'flex',
                minHeight: 0,
                backgroundColor: xStatus.color
              }}>
              <Stack p={2} justifyContent="space-between">
                <Typography variant="caption" color="secondary.main" sx={{ fontWeight: 500 }}>
                  Status
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant="h5" color="secondary.main">
                      <b>{xStatus.text}</b>
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
          </Stack>
          <Stack gap={1} direction={{ xs: 'column', md: 'row' }} flexGrow={1}>
            <Card sx={{ flex: 1, display: 'flex', minHeight: 0 }}>
              <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                  Divergências
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant={{ xs: 'h6', xl: 'h5' }} color="textPrimary">
                      <b>{data.response?.resumo.estatisticas.quantidade_ativos_div || 0}</b>
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
            <Card
              sx={{
                flex: 1,
                display: 'flex',
                minHeight: 0
              }}>
              <Stack px={2} py={2} justifyContent="space-between">
                <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                  Observações
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant={{ xs: 'h6', xl: 'h5' }} color="textPrimary">
                      <b>{data.response?.resumo.estatisticas.quantidade_ativos_obs || 0}</b>
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
            <Card
              sx={{
                flex: 1,
                display: 'flex',
                minHeight: 0
              }}>
              <Stack px={2} py={2} justifyContent="space-between">
                <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                  Ativos Ignorados
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant={{ xs: 'h6', xl: 'h5' }} color="textPrimary">
                      <b>{data.response?.resumo.estatisticas.quantidade_ativos_ignorados || 0}</b>
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
          </Stack>
          <Stack gap={1} direction={{ xs: 'column', md: 'row' }} flexGrow={1}>
            <Card
              sx={{
                flex: 1,
                display: 'flex',
                minHeight: 0
              }}>
              <Stack px={2} py={2} justifyContent="space-between">
                <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                  Divergência entre Quantidades
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant={{ xs: 'h6', xl: 'h5' }} color="textPrimary">
                      <b>{data.response?.resumo.estatisticas.quantidade_ativos_divqtd || 0}</b>
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
            <Card sx={{ flex: 1, display: 'flex', minHeight: 0 }}>
              <Stack px={2} py={2} justifyContent="space-between">
                <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                  Divergência entre Preços
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant={{ xs: 'h6', xl: 'h5' }} color="textPrimary">
                      <b>{data.response?.resumo.estatisticas.quantidade_ativos_divpu || 0}</b>
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
            <Card sx={{ flex: 1, display: 'flex', minHeight: 0 }}>
              <Stack px={2} py={2} justifyContent="space-between">
                <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                  Divergência entre Taxas
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant={{ xs: 'h6', xl: 'h5' }} color="textPrimary">
                      <b>{data.response?.resumo.estatisticas.quantidade_ativos_divtx || 0}</b>
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
          </Stack>
          <Stack gap={1} direction={{ xs: 'column', md: 'row' }} flexGrow={1}>
            <Card
              sx={{
                flex: 1,
                display: 'flex',
                minHeight: 0
              }}>
              <Stack px={2} py={2} justifyContent="space-between">
                <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                  Ativos Ausentes Localmente
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant={{ xs: 'h6', xl: 'h5' }} color="textPrimary">
                      <b>{data.response?.resumo.estatisticas.quantidade_ativos_auslcl || 0}</b>
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
            <Card sx={{ flex: 1, display: 'flex', minHeight: 0 }}>
              <Stack px={2} py={2} justifyContent="space-between">
                <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                  Ativos Ausentes custodiante
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant={{ xs: 'h6', xl: 'h5' }} color="textPrimary">
                      <b>{data.response?.resumo.estatisticas.quantidade_ativos_auscust || 0}</b>
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
          </Stack>
        </Stack>
        <Stack sx={{ gap: 1, flex: 1 }}>
          <Stack gap={1} flexGrow={1} direction={{ xs: 'column', md: 'row' }}>
            <Card sx={{ flex: 1, display: 'flex', minHeight: 0 }}>
              <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                  Ativos Analisados Localmente
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant={{ xs: 'h6', xl: 'h5' }} color="textPrimary">
                      <b>
                        {data.response?.resumo.estatisticas.local_quantidade_ativos_analisados || 0}
                      </b>
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
            <Card
              sx={{
                flex: 1,
                display: 'flex',
                minHeight: 0
              }}>
              <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                  Ativos Analisados Custodiante
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant={{ xs: 'h6', xl: 'h5' }} color="textPrimary">
                      <b>
                        {data.response?.resumo.estatisticas
                          .custodiante_quantidade_ativos_analisados || 0}
                      </b>
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
          </Stack>
          <Stack gap={1} flexGrow={1} direction={{ xs: 'column', md: 'row' }}>
            <Card sx={{ flex: 1, display: 'flex', minHeight: 0 }}>
              <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                  Total Quantidade Local
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant={{ xs: 'h6', xl: 'h5' }} color="textPrimary">
                      <b>
                        {formats.formatNumber(
                          data.response?.resumo.local_quantidade_total || 0,
                          6,
                          true
                        )}
                      </b>
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
            <Card
              sx={{
                flex: 1,
                display: 'flex',
                minHeight: 0
              }}>
              <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                  Total Quantidade Custodiante
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant={{ xs: 'h6', xl: 'h5' }} color="textPrimary">
                      <b>
                        {formats.formatNumber(
                          data.response?.resumo.custodiante_quantidade_total || 0,
                          6,
                          true
                        )}
                      </b>
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
          </Stack>
          <Stack gap={1} flexGrow={1} direction={{ xs: 'column', md: 'row' }}>
            <Card
              sx={{
                flex: 1,
                display: 'flex',
                minHeight: 0
              }}>
              <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                  Total Quantidade Diferença
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant={{ xs: 'h6', xl: 'h5' }} color="textPrimary">
                      <b>
                        {formats.formatNumber(
                          data.response?.resumo.quantidade_total_diferenca || 0,
                          6,
                          true
                        )}
                      </b>
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
          </Stack>
          <Stack gap={1} flexGrow={1} direction={{ xs: 'column', md: 'row' }}>
            <Card sx={{ flex: 1, display: 'flex', minHeight: 0 }}>
              <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                  Total Financeiro Local
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant={{ xs: 'h6', xl: 'h5' }} color="textPrimary">
                      <b>
                        {formats.formatNumber(
                          data.response?.resumo.local_financeiro_total || 0,
                          2,
                          true,
                          true
                        )}
                      </b>
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
            <Card
              sx={{
                flex: 1,
                display: 'flex',
                minHeight: 0
              }}>
              <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                  Total Financeiro Custodiante
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant={{ xs: 'h6', xl: 'h5' }} color="textPrimary">
                      <b>
                        {formats.formatNumber(
                          data.response?.resumo.custodiante_financeiro_total || 0,
                          2,
                          true,
                          true
                        )}
                      </b>
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
          </Stack>
          <Stack gap={1} flexGrow={1} direction={{ xs: 'column', md: 'row' }}>
            <Card
              sx={{
                flex: 1,
                display: 'flex',
                minHeight: 0
              }}>
              <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                  Total Financeiro Diferença
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant={{ xs: 'h6', xl: 'h5' }} color="textPrimary">
                      <b>
                        {formats.formatNumber(
                          data.response?.resumo.financeiro_total_diferenca || 0,
                          2,
                          true,
                          true
                        )}
                      </b>
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};

export default Highlights;
